<script>
    import { Route, Link, Router, router } from 'yrv'
    import ChannelsManager from '../automacao/providers/providers-manager.svelte'
    import CompanyManager from './companies/company-manager.svelte'
    import UserManager from './users/user-manager.svelte'
    import EventLog from './events/event-log.svelte'
    import Referrals from './referrals/referrals.svelte'
    import IntegrationManager from './integrations/integration-manager.svelte'
    import ResourcesManager from './resources/resources-manager.svelte'
    import ChannelsLog from './channels/channels-log.svelte'
    import { onDestroy, onMount } from 'svelte'
    import Services from './services/services.svelte'
    import Payments from './payments/payments.svelte'
    import Outbox from '../automacao/automation-outbox.svelte'
    import Accounts from '../financial/accounts/accounts.svelte'
    import Categories from '../financial/categories/categories.svelte'
    import Products from './products/products.svelte'
    import Consumables from './consumables/consumables.svelte'
    import Schedulers from './schedulers/schedulers.svelte'
    import Packages from './packages/packages.svelte'
    import Ztab from '../_common/z/ztab.svelte'
    import UserPasswordChange from './users/user-password-change.svelte'
    import UserPasswordChangeSuccess from './users/user-password-change-success.svelte'
    import ServiceCategories from './service-categories/service-categories.svelte'
    import ScheduleGroups from './schedule-groups/schedule-groups.svelte'
    import PaymentsGateways from './payments-gateways/payments-gateways.svelte'
    import CustomerServiceModels from './customer-service-models/customer-service-models.svelte'
    import PosQuotationModels from './pos-quotation-models/pos-quotation-models.svelte'
    import Subscription from './subscription/subscription.svelte'
    import GoalboardConfig from './goals/goalboard-config.svelte'
    import TaxParams from './tax/tax-params.svelte'
    import DevicesManager from './devices/devices-manager.svelte'
    import DownloadWindows from '../_common/download-windows.svelte'

    let allowChat = false
    let title = null
    let url = null

    onMount(async () => {
        allowChat = await window.flags('chat', false)
    })

    router.subscribe((e) => loadTab())

    function loadTab() {
        title = ''
        url = '/resources/' + $router.path.split('/')[$router.path.split('/').length - 1]
        if ($router.path.includes('/usuarios')) title = 'Usuários'
        if ($router.path.includes('/devices')) title = 'Dispositivos'
        if ($router.path.includes('/referrals')) title = 'Origens do cliente'
        if ($router.path.includes('/services')) title = 'Serviços'
        if ($router.path.includes('/packages')) title = 'Pacotes'
        if ($router.path.includes('/products')) title = 'Produtos'
        if ($router.path.includes('/consumables')) title = 'Insumos'
        if ($router.path.includes('/accounts')) title = 'Contas bancárias'
        if ($router.path.includes('/categories')) title = 'Categorias financeiras'
        if ($router.path.includes('/service-categories')) title = 'Categorias de serviços'
        if ($router.path.includes('/schedule-groups')) title = 'Grupos de agendas'
        if ($router.path.includes('/payments')) title = 'Meios de Pagamento'
        if ($router.path.includes('/resources-manager')) title = 'Configurações Gerais'
        if ($router.path.includes('/eventos')) title = 'Log de eventos'
        if ($router.path.includes('/empresas')) title = 'Minhas empresas'
        if ($router.path.includes('/channelslog')) title = 'Log dos Provedores'
        if ($router.path.includes('/password-change')) title = 'Senha de Acesso'
        if ($router.path.includes('/payments-gateways')) title = 'Gateways de Pagamento'
        if ($router.path.includes('/customer-service-models')) title = 'Modelos de Atendimento'
        if ($router.path.includes('/pos-quotation-models')) title = 'Modelos de Orçamento'
        if ($router.path.includes('/subscription')) title = 'Minha Assinatura'
        if ($router.path.includes('/goalboard-config')) title = 'Configurações de Metas'
        if ($router.path.includes('/tax-params')) title = 'Notas Fiscais'
        if ($router.path.includes('/download-windows')) title = 'Download para Windows'
    }
</script>

{#if title}
    <div class="root-content">
        <Ztab class="h-space" tabs={[{ title, url }]} />
        <Router>
            <Route path="/scheduler-registration">
                <div>
                    <Schedulers />
                </div>
            </Route>
            <Route path="/goalboard-config">
                <div>
                    <GoalboardConfig></GoalboardConfig>
                </div>
            </Route>
            <Route path="/password-change">
                <div>
                    <UserPasswordChange></UserPasswordChange>
                </div>
            </Route>
            <Route path="/password-change-success">
                <div>
                    <UserPasswordChangeSuccess></UserPasswordChangeSuccess>
                </div>
            </Route>

            <Route path="/services">
                <div>
                    <Services />
                </div>
            </Route>
            <Route path="/service-categories">
                <div>
                    <ServiceCategories></ServiceCategories>
                </div>
            </Route>
            <Route path="/schedule-groups">
                <div>
                    <ScheduleGroups></ScheduleGroups>
                </div>
            </Route>
            <Route path="/packages">
                <div>
                    <Packages />
                </div>
            </Route>
            <Route path="/products">
                <div>
                    <Products />
                </div>
            </Route>
            <Route path="/consumables">
                <div>
                    <Consumables />
                </div>
            </Route>
            <Route path="/accounts">
                <div>
                    <Accounts />
                </div>
            </Route>

            <Route path="/categories">
                <div>
                    <Categories />
                </div>
            </Route>

            <Route path="/payments">
                <div>
                    <Payments />
                </div>
            </Route>

            <Route path="/usuarios">
                <div>
                    <UserManager />
                </div>
            </Route>
            <Route path="/devices">
                <div>
                    <DevicesManager />
                </div>
            </Route>
            <Route path="/referrals">
                <Referrals />
            </Route>
            <Route path="/resources-manager">
                <ResourcesManager />
            </Route>
            <Route path="/empresas">
                <div>
                    <CompanyManager />
                </div>
            </Route>
            <Route path="/eventos">
                <EventLog />
            </Route>
            <Route path="/channelslog">
                <ChannelsLog />
            </Route>
            <Route path="/payments-gateways">
                <PaymentsGateways></PaymentsGateways>
            </Route>
            <Route path="/customer-service-models">
                <CustomerServiceModels></CustomerServiceModels>
            </Route>
            <Route path="/pos-quotation-models">
                <PosQuotationModels></PosQuotationModels>
            </Route>
            <Route path="/subscription">
                <Subscription></Subscription>
            </Route>
            <Route path="/tax-params">
                <TaxParams></TaxParams>
            </Route>
            <Route path="/download-windows">
                <DownloadWindows></DownloadWindows>
            </Route>
        </Router>
    </div>
{/if}

<style>
</style>
